<template>
  <div class="puzzle-rotate-wrapper">
    <div
      class="puzzle-rotate-container"
      :style="containerStyle"
      @touchstart="onTouchStart"
      @touchmove="onTouchMove"
      @touchend="onTouchEnd"
      >
      <img
        :src="attributes.base"
        ref="baseImage"
        id="base-image"
        @load="onImageLoad()"/>
      <img
        v-for="(layer, index) in attributes.layers"
        class="layer-image"
        :key="layer.buttonColor"
        :src="layer.url"
        :style="layerStyle(index)"/>
    </div>
    <div class="layer-selector columns is-mobile is-centered">
      <div
        class="column is-narrow"
        v-for="(layer, index) in attributes.layers"
        :key="layer.buttonColor">
        <div class="layer-selector-btn"
          :style="{'background-color': layer.buttonColor}"
          :class="{'selected-btn': index == this.selectedLayer}"
          @click="selectLayer(index)">
        </div>
      </div>
    </div>
    <div class="columns is-mobile is-centered">
      <div class="column is-narrow">
        <div
          class="button is-default"
          v-if="isValid"
          @click="validate"
          :ref="onDisplaySuccessButton">
          {{ $t("common.congrats") }}&nbsp;<i class="fa fa-angle-right"></i>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import PuzzleMixin from '@/mixins/Puzzle'

export default {
  name: 'SceneRotateAnimation',
  mixins: [PuzzleMixin],
  props: ['attributes', 'number'],
  data () {
    return {
      imageWidth: 0,
      imageHeight: 0,
      selectedLayer: 0,
      rotation: [],
      touching: false,
      touchPreviousPosition: {
        x: 0,
        y: 0
      },
      isValid: false
    }
  },
  created () {
    for (const layer of this.attributes.layers) {
      this.rotation.push(layer.initialRotate)
    }
  },
  mounted () {
    window.addEventListener('resize', this.onResize, false)
  },
  unmounted () {
    window.removeEventListener('resize', this.onResize)
  },
  computed: {
    containerStyle () {
      return {
        height: this.imageHeight.toString() + 'px'
      }
    }
  },
  methods: {
    // On loading image, retrieve the display scale ratio
    onImageLoad () {
      this.onResize()
    },
    onResize () {
      this.imageHeight = this.$refs.baseImage.height
      this.imageWidth = this.$refs.baseImage.width
    },
    onTouchStart (e) {
      if (this.isValid) {
        return
      }
      this.touchPreviousPosition = {
        x: e.touches[0].clientX,
        y: e.touches[0].clientY
      }
      this.touching = true
      e.stopPropagation()
      e.preventDefault()
    },
    onTouchMove (e) {
      if (this.isValid) {
        return
      }
      const newPosition = {
        x: e.changedTouches[0].clientX,
        y: e.changedTouches[0].clientY
      }
      const change = {
        x: newPosition.x - this.touchPreviousPosition.x,
        y: newPosition.y - this.touchPreviousPosition.y
      }
      let rotate = 0
      if (newPosition.y < this.imageHeight / 2) {
        rotate += change.x
      } else {
        rotate -= change.x
      }
      if (newPosition.x < this.imageWidth / 2) {
        rotate -= change.y
      } else {
        rotate += change.y
      }
      this.rotation[this.selectedLayer] += Math.round(rotate / 2)
      if (this.rotation[this.selectedLayer] >= 360) {
        this.rotation[this.selectedLayer] -= 360
      }
      if (this.rotation[this.selectedLayer] < 0) {
        this.rotation[this.selectedLayer] += 360
      }
      this.touchPreviousPosition = newPosition
    },
    onTouchEnd (e) {
      if (this.isValid) {
        return
      }
      this.touching = false
      this.updateSuccess()
    },
    selectLayer (value) {
      this.selectedLayer = value
    },
    layerStyle (index) {
      return {
        transform: 'rotate(' + this.rotation[index].toString() + 'deg)'
      }
    },
    // Are we in a successful state ?
    updateSuccess () {
      for (let i = 0; i < this.attributes.layers.length; i++) {
        if (this.rotation[i] >= 3 && this.rotation[i] <= 357) {
          // Wrong
          this.isValid = false
          return
        }
      }
      // Finish
      for (let i = 0; i < this.attributes.layers.length; i++) {
        this.rotation[i] = 0
      }
      this.touching = false
      this.playVictorySound()
      this.isValid = true
    },
    validate () {
      this.$store.dispatch('validateItem', {
        number: this.number
      })
    },
    onDisplaySuccessButton (el) {
      setTimeout(function () {
        el.scrollIntoView({ behavior: 'smooth' })
      }, 500)
    }
  }
}
</script>

<style scoped lang="sass">
  .puzzle-rotate-wrapper
    padding-top: 40px
    padding-left: 10px
    padding-right: 10px
    .puzzle-rotate-container
      position: relative
  img
    width: 100%
    position: absolute
    top: 0px
    left: 0px
  .layer-selector
    padding-top: 20px
  .layer-selector-btn
    width: 40px
    height: 40px
    border-radius: 20px
    border: solid 2px #333
    box-shadow: 3px 5px #888
  .selected-btn
    box-shadow: none
    margin-top: 5px
  #base-image, .layer-image
    pointer-events: none

</style>
